import React from "react";
import {autorun} from "mobx";
import EsriPopup from "@arcgis/core/widgets/Popup";
import EsriPopupViewModel from "@arcgis/core/widgets/Popup/PopupViewModel";
import EsriFeatureLayer from "@arcgis/core/layers/FeatureLayer";
import EsriGraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import EsriImageryLayer from "@arcgis/core/layers/ImageryLayer";
import EsriMapImageLayer from "@arcgis/core/layers/MapImageLayer";
import EsriGraphic from "@arcgis/core/Graphic";
import EsriPopupTemplate from "@arcgis/core/PopupTemplate";
import EsriHandles from "@arcgis/core/core/Handles";
import FillSymbolProperties = __esri.FillSymbolProperties;
import esriRequest from "@arcgis/core/request";
import {PopupPanel} from "./popup-panel/popup-panel";
import {ContentConfiguration} from "../../config/content-configuration";

import "./popup.scss";

import {UiState} from "../../ui-state";

import {LayerTemplate, PopupConfiguration} from "../../config/popup-configuration";
import {observer} from "mobx-react";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";
import {ExternalServiceDataMappingConfiguration} from "../../config/external-service-configuration";
import {
    Accordion, AccordionTitleProps, Image, Popup as SemanticPopup, Transition
} from "semantic-ui-react";
import FetchPopupFeaturesResult = __esri.FetchPopupFeaturesResult;
import {AppConfiguration} from "../../config/app-configuration";
import {PathUtils} from "../../../utils/path-utils";
import {MapState} from "../../map-state";
import {ActionButtonConfiguration} from "../../config/action-configuration";
import {Icon} from "../icon/icon";
import EsriActionButton from "@arcgis/core/support/actions/ActionButton";
import {SimpleMarkerSymbolConfiguration} from "../../config/symbol-configuration";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import {AppState} from "../../../components/app/app-mobx";
import FieldInfoFormat from "@arcgis/core/popup/support/FieldInfoFormat";


interface PopupProps {
    config: PopupConfiguration;
    mapViewerConfig: MapViewerConfiguration;
    appConfig: AppConfiguration;
    view: __esri.MapView | __esri.SceneView | undefined;
    onLoad?: (sopupViewModel: EsriPopupViewModel) => any;
    uiStore: UiState;
    appStore: AppState;
    mapStore: MapState;
}
interface FeatureGraphics {
    graphics: __esri.Graphic[];
    layerView?: any;
}
// interface ScreenPoint { x:number, y:number };
@observer
export class Popup extends React.Component<PopupProps, any> {
    watchHandles: any[] = [];
    watchHandlesPosition: any[] = [];
    autorunDisposers: any[] = [];
    firstFlag = true;
    panels: any[] = [];
    panelIndex: number;
    popup: any;
    popupRef: any;
    pointerRef: any;
    preparedLayers: string[] = [];
    handles: EsriHandles;
    highlightLayer: EsriGraphicsLayer;
    avlsLayer: EsriFeatureLayer | EsriMapImageLayer | null = null;
    featureGraphics: FeatureGraphics[];
    actionMap: HashMap<number> = {};
    valueUnitMap: Map<string, Map<string, string>> = new Map();
    defaultFormatMap: Map<string, Map<string, FieldInfoFormat>> = new Map();
    nullableFieldType = ["small-integer", "integer", "single", "double", "long", "string"];
    numericFieldType = ["small-integer", "integer", "single", "double", "long"];
    constructor(props: PopupProps) {
        super(props);
        this.state = {
            viewModel: null,
            coordinate: null,
            isLoading: undefined,
            lastItemTitle: "",
            panels: [],
            activeIndex: [1],
            selectedPanelIndex: 1,
            elevation: new Map(),
            activePages: [0, 1],
            pointerPosition: {top: 0, left: 0}
        };
        this.popupRef = React.createRef();
        this.pointerRef = React.createRef();
        this.handleClick = this.handleClick.bind(this);
        this.handleHighlightClick = this.handleHighlightClick.bind(this);
        this.close = this.close.bind(this);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.prepareLayers = this.prepareLayers.bind(this);
        this.externalServiceLoader = this.externalServiceLoader.bind(this);
        this.handles = new EsriHandles();
        this.highlightLayer = new EsriGraphicsLayer({listMode: "hide", title: "popup highlight layer"});
    }

    componentDidMount(): void {
        // rerun until map view is ready and layer list view model is loaded
        this.autorunDisposers.push(autorun((reaction: any) => {
            if (this.props.uiStore.widgets.has("popup")) {
                reaction.dispose(); // stop autorun
                return;
            }
            const {config, view, uiStore} = this.props;
            if (!view) {
                return;
            }
            const popup = this.loadPopup(view);
            if (!popup) {
                return;
            }
            this.popup = popup;
            this.prepareLayers(view.map);
            this.watchHandles.push(
                view.map.watch("allLayers.length", (newValue, oldValue, propertyName, target: __esri.WebMap) => {
                    this.prepareLayers(target);
                })
            );
            view.popupEnabled = false;
            this.setState({
                coordinate: null
            });

            view.map.add(this.highlightLayer);
            // const addLayers: EsriFeatureLayer[] = [];
            // let avls: EsriFeatureLayer | null = null;
            if (typeof config.layers !== "undefined" && config.layers !== null){
                if (config.layers.avls) {
                    const avlsConfig = config.layers.avls;
                    const avlsTemplate = this.getLayerTemplate("avls");
                    if (avlsTemplate) {
                        avlsConfig.popupTemplate = avlsTemplate.template;
                    }
                    if(avlsConfig.layerType === "feature") {
                        this.avlsLayer =
                           new EsriFeatureLayer(avlsConfig as __esri.FeatureLayerProperties);
                    } else if(avlsConfig.layerType === "map-image") {
                        this.avlsLayer =
                            new EsriMapImageLayer(avlsConfig as __esri.MapImageLayerProperties);
                    }
                    if (this.avlsLayer) {
                        this.avlsLayer.load().then((value: any) => {
                            if (value.layerType === "feature") {
                                this.prepareExternalLoader(value);
                            } else if (value.layerType === "map-image") {
                                value.allSublayers.forEach((layer: __esri.Sublayer) => {
                                    if (avlsConfig.popupTemplate) {
                                        layer.popupTemplate = new EsriPopupTemplate(
                                            avlsConfig.popupTemplate as
                                                __esri.PopupTemplateProperties);
                                        layer.definitionExpression = avlsConfig.definitionExpression;
                                        this.prepareExternalLoader(layer);
                                    }
                                });
                            }
                        });
                    }
                }
            }
            // const handles = new EsriHandles();
            this.watchHandles.push(
                view.on("click", (event) => {
                    // Make sure that there is a valid mapPoint
                    if (event && event.mapPoint && !uiStore.popupDisabled) {
                        uiStore.setPopupVisible(true);
                        this.open(event.mapPoint);
                    }
                })
            );
            const highlightSymbol = config.highlightSymbol as FillSymbolProperties;
            // This event fires for each click on any popup action
            // popup.on("trigger-action", (event) => {});
            this.watchHandles.push(
                reactiveUtils.watch(
                    () => this.popup.visible,
                    (newValue: boolean) => {
                        uiStore.setPopupVisible(newValue);
                    })
            );
            this.watchHandles.push(
                reactiveUtils.watch(
                    () => this.popup?.selectedFeature,
                    (graphic: any) => {
                        if (this.popup.highlightEnabled) {
                            this.highlightLayer.removeAll();
                            if (graphic) {
                                if (graphic.sourceLayer.opacity === 0) {
                                    this.highlightLayer.add(
                                        new EsriGraphic({geometry: graphic.geometry, symbol: highlightSymbol}));
                                }
                            }
                        }
                    })
            );
            this.setState({
                viewModel: this.popup.viewModel
            });
            this.props.uiStore.addWidget("popup", this);

            if (this.props.onLoad) {
                // call the hook
                this.props.onLoad(this.popup.viewModel);
            }

            this.autorunDisposers.push(autorun((visibilityReaction: any) => {
                if(uiStore.popupVisible) {
                    if (!this.props.uiStore.popupVisible) {
                        this.close();
                        visibilityReaction.dispose();
                    }
                }
            }));
            reaction.dispose();
        }));
    }
    prepareLayers(map: __esri.Map): void {
        map.allLayers.forEach((layer: __esri.Layer) => {
            if (this.preparedLayers.indexOf(layer.id) === -1) {
                this.preparedLayers.push(layer.id);
                layer.load().then((value: any) => {
                    let url = value.get("parsedUrl")?.path;
                    if (!url) {
                        url = value.get("url"); // MapImageLayer Service
                    }
                    let metauid = "";
                    if (typeof url === "string") {
                        metauid = PathUtils.getMetaId(url);
                    }
                    this.prepareTemplate(value, metauid);
                    if (value.type === "map-image") {
                        value.allSublayers.forEach((subL: __esri.Sublayer) => {
                            this.prepareTemplate(subL, metauid);
                        });
                    }
                });
            }
        });
    }
    getLayerTemplate(metauid: string, layerId?: number): LayerTemplate | undefined {
        const layerTemplates = this.props.config.layerTemplates;
        if(layerTemplates && metauid) {
            // `${metauid}-${layer.id}`
            const layerTemplate = layerTemplates.find((t)=>
                t.metauid === metauid && (!t.layerIds || t.layerIds.length===0 ||
                    (typeof layerId !== "undefined" && t.layerIds.includes(layerId))));
            return layerTemplate;
        }
        return;
    }
    prepareTemplate(layer: any, metauid: string): void {
        // In Feldnamen nach Masseinheiten suchen, diese in einer Map ablegen und im Namen entfernen.
        this.watchHandles.push(reactiveUtils.when(
            ()=> layer.popupTemplate?.fieldInfos,
            () => {
                this.prepareUnits(layer);
            },
            { initial: true, once: true }
        ));
        this.watchHandles.push(reactiveUtils.when(
            ()=> layer.popupTemplate?.content,
            () => {
                this.prepareUnits(layer);
            },
            { initial: true, once: true }
        ));
        const layerTemplate = this.getLayerTemplate(metauid, layer.id);
        // Template aus Konfiguration ergänzen
        if (layerTemplate) {
            // create a basic template if none exists
            if (typeof layer.popupTemplate === "undefined" || !layer.popupTemplate) {
                layer.popupTemplate = new EsriPopupTemplate();
                layer.popupTemplate.content = [];
                // ennsure that a template has a title
                layer.popupTemplate.title = layer.title;
            }
            if (layerTemplate.mode === "append") {
                layer.popupTemplate.content =
                    layer.popupTemplate.content.concat(layerTemplate.template.content);
            } else if (layerTemplate.mode === "prepend") {
                if (Array.isArray(layerTemplate.template.content)) {
                    layer.popupTemplate.content =
                        (layerTemplate.template.content as ContentConfiguration[]).concat(
                            layer.popupTemplate.content);
                }
            } else if (layerTemplate.mode === "replace") {
                layer.popupTemplate = layerTemplate.template;
            }
            if (layerTemplate.template.actions) {
                if (Array.isArray(layer.popupTemplate.actions)){
                    layer.popupTemplate.actions =
                        layer.popupTemplate.actions.concat(layerTemplate.template.actions);
                } else {
                    layer.popupTemplate.actions = layerTemplate.template.actions;
                }
            }
            this.prepareExternalLoader(layer);
        }
    }
    prepareUnits(layer: any): void {
        const unitMap = new Map();
        if(layer.popupTemplate.fieldInfos
            && Array.isArray(layer.popupTemplate.fieldInfos)) {
            layer.popupTemplate.fieldInfos.forEach((fieldInfo: __esri.FieldInfo) => {
                const regExp = new RegExp(" \\[(.+)?\\]$");
                if(regExp.test(fieldInfo.label)) {
                    const matches = fieldInfo.label.match(regExp);
                    if (matches && matches.length === 2) {
                        unitMap.set(fieldInfo.fieldName,
                            matches[1].replace("m2","m²"));
                        fieldInfo.label = fieldInfo.label.replace(regExp, "");
                    }
                }
            });
        }
        if (layer.popupTemplate.content && Array.isArray(layer.popupTemplate.content)) {
            layer.popupTemplate.content.forEach((content: __esri.FieldsContent) => {
                if(content.type==="fields" && Array.isArray(content.fieldInfos)) {
                    content.fieldInfos.forEach((fieldInfo: __esri.FieldInfo) => {
                        const regExp = new RegExp(" \\[(.+)?\\]$");
                        if (regExp.test(fieldInfo.label)) {
                            const matches = fieldInfo.label.match(regExp);
                            if (matches && matches.length === 2) {
                                unitMap.set(fieldInfo.fieldName,
                                    matches[1].replace("m2", "m²"));
                                fieldInfo.label = fieldInfo.label.replace(regExp, "");
                            }
                        }
                    });
                }
            });
        }
        if (unitMap.size > 0){
            // Das Property uid ist nicht dokumentiert!
            this.valueUnitMap.set((layer as any).uid, unitMap);
        }
    }
    prepareDefaultFormat(layer: any): void {
        if(this.defaultFormatMap.get(layer.uid as string)) {return;}
        const fieldMap = new Map();
        if(layer.popupTemplate.fieldInfos
            && Array.isArray(layer.popupTemplate.fieldInfos)) {
            layer.popupTemplate.fieldInfos.forEach((fieldInfo: __esri.FieldInfo) => {
                const fieldType = layer.getField(fieldInfo.fieldName)?.type;
                // Datumsformat vorgeben falls nicht definiert
                if(!fieldInfo.format && fieldType==="date"){
                    fieldInfo.format = new FieldInfoFormat({dateFormat: "short-date"});
                }
                fieldMap.set(fieldInfo.fieldName,fieldInfo.format?.clone());
                // Bei numerischen Werte Formatierung für SDK entfernen
                if(this.numericFieldType.indexOf(fieldType) > -1){
                    fieldInfo.format = new FieldInfoFormat();
                }
            });
        }
        if (layer.popupTemplate.content && Array.isArray(layer.popupTemplate.content)) {
            layer.popupTemplate.content.forEach((content: __esri.FieldsContent) => {
                if(content.type==="fields" && Array.isArray(content.fieldInfos)) {
                    content.fieldInfos.forEach((fieldInfo: __esri.FieldInfo) => {
                        const fieldType = layer.getField(fieldInfo.fieldName)?.type;
                        // Datumsformat vorgeben falls nicht definiert
                        if(!fieldInfo.format && fieldType==="date"){
                            fieldInfo.format = new FieldInfoFormat({dateFormat: "short-date"});
                        }
                        fieldMap.set(fieldInfo.fieldName,fieldInfo.format?.clone());
                        // Bei numerischen Werte Formatierung für SDK entfernen
                        if(this.numericFieldType.indexOf(fieldType) > -1){
                            fieldInfo.format = new FieldInfoFormat();
                        }
                    });
                }
            });
        }
        // Das Property uid ist nicht dokumentiert!
        this.defaultFormatMap.set((layer as any).uid, fieldMap);
    }
    prepareExternalLoader(layer: any): void {
        if (typeof layer.popupTemplate !== "undefined" && layer.popupTemplate !== null){
            if (Array.isArray(layer.popupTemplate.content)) {
                layer.popupTemplate.content.forEach((content: any) => {
                    if (content.type === "custom" && typeof content.creator === "string") {
                        if (content.creator === "externalServiceLoader" && content.serviceID) {
                            content.creator =
                                (element: any) => this.externalServiceLoader(element.graphic, content.serviceID, layer);
                        }
                    }
                });
            }
            if (typeof layer.popupTemplate.actions !== "undefined" && layer.popupTemplate.actions !== null) {
                this.popup.viewModel.includeDefaultActions = false;
                layer.popupTemplate.actions.forEach((actionConfig: ActionButtonConfiguration) => {
                    if (typeof actionConfig.id !== "undefined") {
                        const predefinedAction =
                            this.props.appConfig.predefinedActions.find((action) =>
                                actionConfig.id === action.id);
                        // add missing attributes
                        if (predefinedAction) {
                            if (!("title" in actionConfig) || !actionConfig.title){
                                actionConfig.title = predefinedAction.title;
                            }
                            if (predefinedAction.url && (!("url" in actionConfig) || !actionConfig.url)){
                                actionConfig.url = predefinedAction.url;
                            }
                            if (predefinedAction.query && (!("query" in actionConfig) || !actionConfig.query)){
                                actionConfig.query = predefinedAction.query;
                            }
                            if (predefinedAction.icon && (!("icon" in actionConfig) || !actionConfig.icon)){
                                actionConfig.icon = predefinedAction.icon;
                            }
                        }
                        this.actionMap[actionConfig.id] = this.popup.viewModel.allActions.length;
                        this.popup.viewModel.actions.push(actionConfig as EsriActionButton);
                    }
                });
            }
        }
    }

    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        this.removePositionHandles();
    }
    loadPopup(view: __esri.MapView | __esri.SceneView): EsriPopup {
        const config = this.props.config as __esri.PopupProperties;
        config.container = this.popupRef.current;
        const props = {
            view,
            ...config
        };
        return new EsriPopup(props);
        // return popup;
    }
    externalServiceLoader(graphic: EsriGraphic, serviceID: string,
                          sourceLayer: EsriFeatureLayer | EsriImageryLayer): string | Promise<string> {
        const service = this.props.appConfig.externalServices.find(
            (element: any) => element.id === serviceID);
        if (!service) {
            return "<strong>Service nicht gefunden!</strong>";
        }
        const requestOptions = {} as __esri.RequestOptions;
        requestOptions.responseType = service.xhrOptions.responseType;
        if (service.xhrOptions.usePost) {
            requestOptions.method = "post";
        }
        if (service.xhrOptions.timeout) {
            requestOptions.timeout = service.xhrOptions.timeout;
        }
        const requestData = {
            version: PathUtils.getVersion(sourceLayer.url)
        };
        let appendTable = true;
        service.xhrOptions.dataMapping.forEach((mappingObj: ExternalServiceDataMappingConfiguration) => {
            if (typeof mappingObj.source === "string") {
                if (mappingObj.source === "layer") {
                    if (typeof mappingObj.map !== "undefined") {
                        let layerId: number;
                        if (sourceLayer instanceof EsriFeatureLayer) {
                            layerId = sourceLayer.layerId;
                        } else {
                            // sourceLayer on Graphic is not documented!
                            layerId = (graphic as any).sourceLayer.id;
                        }
                        if (mappingObj.map[layerId]) {
                            requestData[mappingObj.requestParam] = mappingObj.map[layerId];
                            appendTable = false;
                        }
                    }
                    //
                } else if (typeof mappingObj.property === "string") {
                    const tempAttribute = graphic.getAttribute(mappingObj.property);
                    if (typeof tempAttribute !== "undefined") {
                        requestData[mappingObj.requestParam] = tempAttribute;
                    }
                }
            } else if (typeof mappingObj.property === "string") {
                const tempAttribute = graphic.getAttribute(mappingObj.property);
                if (typeof tempAttribute !== "undefined") {
                    requestData[mappingObj.requestParam] = tempAttribute;
                }
            }
        });
        requestOptions.body = JSON.stringify({ params: [requestData]});
        return esriRequest(service.url, requestOptions).then((response: __esri.RequestResponse) => {

            let htmlData = "";
            if ( response.data !== "undefined"){
                htmlData = response.data.replaceAll("href=\"#", "target=\"_self\" href=\""+window.location.href+"#");
            }
            if (appendTable) {
                htmlData = "<table class=\"esri-widget__table inverse\">" + htmlData + "</table>";
            }
            return htmlData;
        }).catch(() => "<div class=\"error\">" + service.errorMessage + "</div>");
    }
    handleClick(e: React.MouseEvent, titleProps: AccordionTitleProps): void {
        this.setState(() => {
            const { index } = titleProps;
            const { activeIndex, selectedPanelIndex, activePages } = this.state;

            let newIndexes;
            let newSelectedPanelIndex = selectedPanelIndex;
            if (activeIndex.includes(index)) {
                // hide tab by removing index from list
                newIndexes = activeIndex.filter((item: number) => item !== index);
                if (selectedPanelIndex === index ) {
                    newSelectedPanelIndex = -1;
                }
                this.highlight((index as number) * -1, 0);
            } else {
                // show panel by adding to list
                if (this.props.config.exclusiveFeature) {
                    // only open the exclusive tab
                    newIndexes = [index];
                } else {
                    // via Set sollte das Array unique und sortiert sein
                    newIndexes = [...new Set([...activeIndex, index])].sort();
                }
                this.highlight(index as number, activePages[index as number]);
                newSelectedPanelIndex = index as number;
            }
            return { activeIndex: newIndexes, selectedPanelIndex: newSelectedPanelIndex };
        });
    }
    handleHighlightClick(e: React.MouseEvent, panelIndex: number, index: number): void {
        const { selectedPanelIndex } = this.state;
        if (panelIndex !== selectedPanelIndex){
            this.highlight(panelIndex, index);
        }
        this.setState( { selectedPanelIndex: panelIndex });
    }
    handleZoomInClick(e: React.MouseEvent, panelIndex: number, index: number): void {
        const featureGraphic = this.featureGraphics[panelIndex - 1];
        const graphicIndex = index - 1;
        if (featureGraphic && typeof this.props.view !== "undefined") {
            if (featureGraphic.graphics[graphicIndex].geometry?.type === "point"){
                const scale = 2256;
                this.props.view.goTo({target: featureGraphic.graphics[graphicIndex], scale}).catch((error) => {
                    if (error.name !== "view:goto-interrupted") {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                });
            }else{
                this.props.view.goTo(featureGraphic.graphics[graphicIndex]).catch((error) => {
                    if (error.name !== "view:goto-interrupted") {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                });
            }
        }
    }
    highlight(panelIndex: number, index: number): void {
        const graphicIndex = index - 1;
        if (panelIndex < 0){
            const { activeIndex, selectedPanelIndex } = this.state;
            if (selectedPanelIndex < 0
                || Math.abs(panelIndex) === selectedPanelIndex
                || !activeIndex.includes(selectedPanelIndex)) {
                this.handles.removeAll();
                if (typeof this.props.view !== "undefined") {
                    this.highlightLayer.removeAll();
                }
            }
        } else {
            const featureGraphic = this.featureGraphics[panelIndex - 1];
            // this.handles.add(fetchResult.layerView.highlight(this.featureGraphics[panelIndex]))
            const highlightSymbol = this.props.config.highlightSymbol as FillSymbolProperties;
            if (this.popup.highlightEnabled && typeof this.props.view !== "undefined") {
                this.handles.removeAll();
                this.highlightLayer.removeAll();
                if (featureGraphic.graphics[graphicIndex]) {
                    // sourceLayer on Graphic is not documented!
                    if ((featureGraphic.graphics[graphicIndex] as any).sourceLayer.opacity === 0
                        || typeof featureGraphic.layerView === "undefined"
                        || typeof featureGraphic.layerView.highlight !== "function") {
                        this.highlightLayer.add(
                            new EsriGraphic({geometry: featureGraphic.graphics[graphicIndex].geometry,
                                symbol: highlightSymbol}));
                    } else {
                        if (featureGraphic.layerView.layer.declaredClass === "esri.layers.MapImageLayer"
                        && featureGraphic.graphics[graphicIndex].geometry.type==="polygon"){
                            this.highlightLayer.add(
                                new EsriGraphic({geometry: featureGraphic.graphics[graphicIndex].geometry,
                                    symbol: highlightSymbol}));
                        } else {
                            this.handles.add(featureGraphic.layerView.highlight(featureGraphic.graphics[graphicIndex]));
                        }
                    }
                    this.props.mapStore.selectFeature(featureGraphic.graphics[graphicIndex]);
                }
            }
        }
    }
    addFeatures(mapPoint: __esri.Point, features: __esri.Graphic[]): void {
        this.firstFlag = false;
        this.setState({isLoading: true});
        features.forEach((graphic: __esri.Graphic) => {
            const source = graphic.get("sourceLayer") as __esri.Layer;
            if (source) {
                const url = source.get("url");
                let metauid = "custom";
                if (typeof url === "string") {
                    metauid = PathUtils.getMetaId(url);
                }
                this.prepareTemplate(source, metauid);
                this.prepareUnits(source);
                this.prepareExternalLoader(source);
            }
        });
        this.prepareFeatures(features, mapPoint);
        this.setState({
            isLoading: false
        });
    }
    open(mapPoint: __esri.Point, features?: __esri.Graphic[]): void {
        const {view, mapViewerConfig, uiStore} = this.props;
        if (!view) {
            return;
        }
        if (uiStore.popupDisabled) {
            return;
        }
        this.setState({isLoading: true});
        if (!this.props.config.dockEnabled) {
            this.close();
        }
        this.handles.removeAll();
        this.featureGraphics = [];
        // const mapPoint = view.toMap(screenPoint);
        const screenPoint = view.toScreen(mapPoint);
        view.graphics.removeAll();
        if (this.props.config.dockEnabled && !features) {
            const isSmallDevice = window.matchMedia("(max-width: "+mapViewerConfig.breakpoints.md+"px)").matches;
            // reposition center if needed
            if (!isSmallDevice && document.documentElement.clientWidth - screenPoint.x < 420){
                // calculate new center
                const newX = document.documentElement.clientWidth / 2
                    + 520 - (document.documentElement.clientWidth - screenPoint.x);
                view.goTo({center: view.toMap({ x: newX,
                    y: document.documentElement.clientHeight / 2 })}).catch((error) => {
                    if (error.name !== "view:goto-interrupted") {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                });
            }
        }
        // unsichtbarer Punkt welcher für die Spinner- und Popup-Positionierung verwendet wird
        view.graphics.add(new EsriGraphic({
            symbol: {
                type: "simple-marker",
                style: "circle",
                size: 1,
                color: [255, 255, 255, 0]
            } as SimpleMarkerSymbolConfiguration,
            geometry: mapPoint
        }));
        this.setState({pointerPosition: {top: screenPoint.y, left: screenPoint.x - 20, width: 40}});
        this.addPositionHandles(view);
        this.panels = [];
        this.setState({panels: this.panels});
        this.panelIndex = 1;
        if (this.props.appConfig.elevationLayers && this.props.appConfig.elevationLayers.length > 0) {
            view.map.ground.layers.forEach((eLayer)=> {
                eLayer.queryElevation(mapPoint).then((result) => {
                    if (result.geometry.type === "point") {
                        this.setState((state: any)=>{
                            const {elevation} = state;
                            if ("z" in result.geometry) {
                                elevation.set(eLayer.id, { value: result.geometry.z, title: eLayer.title});
                            } else {
                                elevation.set(eLayer.id, { value: 0 });
                            }
                            return elevation;
                        });
                    }
                });
            });
        }
        if (features){
            features.forEach((graphic: __esri.Graphic) => {
                const source = graphic.get("sourceLayer") as __esri.Layer;
                if (source) {
                    const url = source.get("url");
                    let metauid = "custom";
                    if (typeof url === "string") {
                        metauid = PathUtils.getMetaId(url);
                    }
                    this.prepareTemplate(source, metauid);
                    this.prepareUnits(source);
                    this.prepareExternalLoader(source);
                }
            });
            this.firstFlag = true;
            this.prepareFeatures(features, mapPoint);
            this.setState({
                isLoading: false,
                coordinate: view.toMap({ x: screenPoint.x, y: screenPoint.y })
            });
            if (this.featureGraphics.length === 0) {
                this.close();
            } else {
                if (this.props.config.dockEnabled) {
                    this.removePositionHandles(view);
                    view.graphics.add(new EsriGraphic({
                        symbol: this.props.config.pointerSymbol,
                        geometry: mapPoint
                    }));
                }
            }
            return;
        }
        this.popup.fetchFeatures(screenPoint).then((response: FetchPopupFeaturesResult) => {
            this.firstFlag = true;
            if (!response.promisesPerLayerView) {
                return;
            }
            const promises: Array<Promise<any>> = [];
            response.promisesPerLayerView.forEach((fetchResult) => {
                const layerView = fetchResult.layerView;
                if (!layerView.layer.get("popupEnabled")) {
                    return;
                }
                promises.push(fetchResult.promise);
                // Iterate through the promise results to access its graphics
                fetchResult.promise.then((graphics) => {
                    this.prepareFeatures(graphics, mapPoint);
                });
            });
            // Wait until all promises are fulfilled
            Promise.all(promises).then(() => {
                if (this.avlsLayer) {
                    let queryLayer: __esri.FeatureLayer | __esri.Sublayer;
                    if (this.avlsLayer.hasOwnProperty("allSublayers")) {
                        queryLayer = (this.avlsLayer as EsriMapImageLayer).allSublayers.getItemAt(0);
                    } else {
                        queryLayer = this.avlsLayer as EsriFeatureLayer;
                    }
                    queryLayer.queryFeatures({
                        geometry: mapPoint,
                        outFields: ["bfs_nr", "egris_egrid", "gbper_code", "gbper_name",
                            "gemeinde", "nummer", "flaechenmass"],
                        returnGeometry: true,
                        where: queryLayer.definitionExpression
                    }).then((featureSet) => {
                        let title = "";
                        if (this.avlsLayer) {
                            title = this.avlsLayer.title;
                        }
                        this.featureGraphics.push({graphics: featureSet.features});
                        this.panels.push(<PopupPanel
                            appConfig={this.props.appConfig}
                            config={this.props.config}
                            graphics={featureSet.features}
                            title={title}
                            popup={this}
                            mapViewerConfig={this.props.mapViewerConfig}
                            view={this.props.view}
                            uiStore={this.props.uiStore}
                            index={this.panelIndex}
                            key={this.panelIndex}/>
                        );
                        this.panelIndex++;
                        this.setState({panels: this.panels, isLoading: false});
                        if (this.props.config.dockEnabled) {
                            this.removePositionHandles(view);
                            view.graphics.add(new EsriGraphic({
                                symbol: this.props.config.pointerSymbol,
                                geometry: mapPoint
                            }));
                        }
                        // Falls nur AVLs Daten vorhanden, das Panel auf aktiv setzen
                        if (this.panelIndex === 2){
                            uiStore.setPopupVisible(true);
                            this.setState({selectedPanelIndex: 1});
                            this.highlight(1, 1);
                        }
                    });
                } else {
                    this.setState({isLoading: false});
                    if (this.featureGraphics.length === 0) {
                        this.close();
                    } else {
                        if (this.props.config.dockEnabled) {
                            this.removePositionHandles(view);
                            view.graphics.add(new EsriGraphic({
                                symbol: this.props.config.pointerSymbol,
                                geometry: mapPoint
                            }));
                        }
                    }
                }
            });
            this.setState({
                coordinate: view.toMap({ x: screenPoint.x, y: screenPoint.y })
            });
        });
    }
    prepareFeatures(graphics: __esri.Graphic[], mapPoint: __esri.Point, layerView?: __esri.LayerView): void {
        const {config, uiStore, view} = this.props;
        if (graphics.length > 0) {
            if (layerView && layerView.layer.opacity === 0) {
                // show only first element on transparent layer
                graphics = [graphics[0]];
            }
            // Reseultate anhand von Sublayers gruppieren. Wird für MapImageLayer benötigt
            const graphicsGroup = new Map();
            graphics.forEach((graphic: __esri.Graphic) => {
                const source = graphic.get("sourceLayer") as __esri.Sublayer;
                if (source) {
                    const groupSource: __esri.Sublayer
                        = ((source as any).type!=="feature" && source.get("parent")
                        && (source.get("parent") as any).type!=="map-image")?
                            source.get("parent"): source;
                    if (!graphicsGroup.has(groupSource.id)){
                        graphicsGroup.set(groupSource.id,
                            {title: groupSource.title,
                                graphics: []}
                        );
                    }
                    if (!config.exclusiveFeature
                        || graphicsGroup.get(groupSource.id).graphics.length < 1) {
                        graphicsGroup.get(groupSource.id).graphics.push(graphic);
                    }
                }
            });
            if(layerView && layerView.layer.declaredClass === "esri.layers.MapImageLayer"
                && (layerView.layer as __esri.MapImageLayer).capabilities.operations.supportsQuery) {
                const graphicPromises: Array<Promise<any>> = [];
                // Detailierte Geometrie abfragen
                graphicsGroup.forEach((group) => {
                    group.graphics.forEach((graphic: __esri.Graphic)=>{
                        const source = graphic.get("sourceLayer");
                        if (source) {
                            const graphicPromise = (source as __esri.Sublayer).queryFeatures({
                                where: "OBJECTID=" + graphic.getObjectId(),
                                outFields: ["OBJECTID"],
                                returnGeometry: true
                            });
                            graphicPromises.push(graphicPromise);
                            graphicPromise.then((featureSet: __esri.FeatureSet) => {
                                if (featureSet.features.length > 0) {
                                    graphic.geometry = featureSet.features[0].geometry;
                                }
                            });
                        }
                    });
                });
                Promise.all(graphicPromises).then(() => {
                    const {activeIndex, selectedPanelIndex } = this.state;
                    this.highlight(selectedPanelIndex, activeIndex[0]);
                });
            }
            if (config.visibleElements.featureNavigation) {
                if (config.exclusiveFeature) {
                    // show only first element
                    graphics = [graphics[0]];
                }
                if (this.firstFlag) {
                    view?.openPopup({location: mapPoint, features: graphics});
                    this.firstFlag = false;
                } else {
                    this.popup.features = this.popup.features.concat(graphics);
                }
            } else {
                if (this.firstFlag) {
                    this.firstFlag = false;
                    uiStore.setPopupVisible(true);
                    this.highlightLayer.removeAll();
                    this.popup.selectedFeatureIndex = this.panelIndex;
                }
                graphicsGroup.forEach((group) => {
                    this.featureGraphics.push({graphics: group.graphics, layerView});
                    this.panels.push(<PopupPanel
                        appConfig={this.props.appConfig}
                        config={config}
                        graphics={group.graphics}
                        title={group.title}
                        popup={this}
                        mapViewerConfig={this.props.mapViewerConfig}
                        view={this.props.view}
                        uiStore={this.props.uiStore}
                        index={this.panelIndex}
                        key={this.panelIndex}/>

                    );
                    this.panelIndex++;
                    this.setState({panels: this.panels});
                    const { activeIndex } = this.state;
                    let newIndexes = activeIndex;
                    if (config.exclusiveFeature) {
                        // only open the exclusive tab
                        newIndexes = [1];
                    } else {

                        if (!activeIndex.includes(1)) {
                            newIndexes = [...activeIndex, 1].sort();
                        }
                    }
                    this.setState({activeIndex: newIndexes, selectedPanelIndex: 1});
                    this.highlight(1, 1);
                });
            }
        }
    }
    close(): void {
        const {mapStore, uiStore, view} = this.props;
        if (view) {
            view.graphics.removeAll();
            this.highlightLayer.removeAll();
            mapStore.selectFeature(null);
        }
        if (this.handles) {
            this.handles.removeAll();
        }
        view?.closePopup();
        this.removePositionHandles();
        uiStore.setPopupVisible(false);
    }
    toggleVisibility(): void {
        const {uiStore} = this.props;
        uiStore.setPopupVisible(!uiStore.popupVisible);
    }
    addPositionHandles(view: __esri.MapView | __esri.SceneView): void {
        this.watchHandlesPosition.push(
            view.on("resize", () => {
                this.calcPointerPosition();
            })
        );
        this.watchHandlesPosition.push(
            view.watch("center", () => {
                this.calcPointerPosition();
            })
        );
        this.watchHandlesPosition.push(
            view.watch("zoom", () => {
                this.calcPointerPosition();
            })
        );
    }
    removePositionHandles(view?: __esri.MapView | __esri.SceneView): void {
        if (view) {
            view.graphics.removeAll();
        }
        this.watchHandlesPosition.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandlesPosition.length = 0;
    }
    calcPointerPosition(): void {
        const { view } = this.props;
        if (!view) {
            return;
        }
        const pointer = view.graphics.getItemAt(0);
        if (pointer && pointer.geometry.type === "point") {
            const screenPoint = view.toScreen(pointer.geometry as __esri.geometry.Point);
            const geoContainer = document.getElementsByClassName("geo-ui-inner-container")[0];
            const visible = !(screenPoint.x < 0 || screenPoint.y < 0
                || screenPoint.x > geoContainer.clientWidth || screenPoint.y > geoContainer.clientHeight);
            this.setState({pointerPosition: {top: screenPoint.y, left: screenPoint.x - 20, width: 40}, visible});
        }
    }
    render(): JSX.Element | null {
        const { coordinate, elevation, isLoading, panels, activeIndex, pointerPosition, lastItemTitle }
            = this.state;
        const { config, uiStore} = this.props;
        let coords = null;
        let pointerSymbol = null;
        if (coordinate && config.visibleElements.coordinates){
            if (config.pointerSymbol && config.pointerSymbol.type === "picture-marker") {
                pointerSymbol = (
                    <Image src={config.pointerSymbol.url} height="28" verticalAlign="middle" floated="left" />
                );
            }
            const x = new Intl.NumberFormat("de-CH").format(Math.round(coordinate.x));
            const y = new Intl.NumberFormat("de-CH").format(Math.round(coordinate.y));
            const eElement = [...elevation.values()].filter(
                (e) => e.value > 0)
                .map((e) =>
                    new Intl.NumberFormat("de-CH").format(Math.round(e.value)) + " m.ü.M. (" + e.title + ")");
            let eString = "";
            if (eElement.length > 0) {
                eString = "Höhe: " + eElement.join(", ");
            }
            coords = (<div>Lage: E {x} / N {y}<br />{eString}</div>);
        }

        let addClass = "geo-popup geo-component geo-widget";
        if (config.dockEnabled) {
            addClass += " docked docked-" + config.dockOptions.position;
            return (
                <>
                    <div
                        className={"geo-popup-spinner"
                            + (isLoading!==undefined?(isLoading? " geo-spinner-visible": " geo-spinner-hidden"):"")}
                        style={pointerPosition}>
                        <Icon name={"recycle"} className={"geo-rotating"} selected={true}/>
                    </div>
                    <Transition visible={uiStore.popupVisible} duration={0} mountOnShow={false}>
                        <div className={addClass}>
                            <div className="geo-popup-content">
                                <div onClick={this.close} className={"geo-close"}><Icon name="navigate_cross" /></div>
                                <div className="geo-popup-features">
                                    {config.visibleElements.featureNavigation ?
                                        <div ref={this.popupRef}/>
                                        :
                                        <Accordion className={"geo-popup-accordion"}
                                            styled fluid={true}
                                            defaultActiveIndex={activeIndex}
                                            exclusive={false}
                                            panels={panels}/>
                                    }
                                </div>
                                <div className="popup-content-coordinates">{pointerSymbol}{coords}</div>
                            </div>
                        </div>
                    </Transition>
                </>
            );
        } else {
            addClass += " not-docked";
            return (
                <div>
                    <div
                        className={"geo-popup-spinner"
                            + (isLoading!==undefined?(isLoading? " geo-spinner-visible": " geo-spinner-hidden"):"")}
                        style={pointerPosition}>
                        <Icon name={"recycle"} className={"geo-rotating"} selected={true}/>
                    </div>
                    <div ref={this.pointerRef} className="geo-popup-pointer-ref" style={pointerPosition} />
                    <SemanticPopup open={uiStore.popupVisible}
                        className={"geo-popup"}
                        context={this.pointerRef} wide={"very"} popperDependencies={[pointerPosition, lastItemTitle]}>
                        <Icon onClick={this.close} className={"geo-close"} name="navigate_cross" />
                        <div className={addClass}>
                            <div className="geo-popup-content">
                                <div className="geo-popup-features">
                                    {config.visibleElements.featureNavigation ?
                                        <div ref={this.popupRef}/>
                                        :
                                        <Accordion className={"geo-popup-accordion"}
                                            styled fluid={true}
                                            defaultActiveIndex={activeIndex}
                                            exclusive={false}
                                            panels={panels}/>
                                    }
                                </div>
                                <div className="popup-content-coordinates">{pointerSymbol}{coords}</div>
                            </div>
                        </div>
                    </SemanticPopup>
                </div>
            );
        }
    }
}
